import BaseUtil from "../../util/BaseUtil";
const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    initializing: true,
    inviteStatus: null, // 被邀请状态
    lastApplication: null, // 上一次的档案申请

    inviteModalVisible: false, // 邀请填写modal,
    inviteModalEditable: false, // 邀请填写页面是否可编辑（分为查看已填写和修改）
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
